import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'roleCutAppSlug'})
export class roleCutAppSlugPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/.*\_/g, '');
  }
}